import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";
import Multiselect from "multiselect-react-dropdown";
import NoData from "../../sharedComponent/NoData";
import React, { useContext, useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { AppContext } from "../../context/AppContext";
import { ToastMsg } from "../TostMsg";
import Select from "react-select";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithToken,
} from "../../api/ApiServices";
import { strongPassword } from "../../common";

const GeneralSetting = () => {
  const { sidebar, setSidebar, Dark, setDark, userData } =
    useContext(AppContext);
  const multiselectRef = useRef();
  const [employeeNames, setEmployeeNames] = useState([]);
  const [empName, setEmpName] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [genericUserId, setgenericUserId] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [defaultSelectedUser, setDefaultSelectedUser] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState([]);
  const [userId, setUserId] = useState('');

  const [isPasswordValided,setIsPasswordValided] = useState(false)
  const [isGenericValided,setIsGnericValided] = useState(false)


  const [mapping, setMapping] = useState(false);
  console.log("selectedUser", selectedUser);

  const onSelect = (selectedList) => {
    console.log("selectedList", selectedList);
    const employeeIdArr = selectedList?.map((item) => item.id) || [];
    // let employeeIdArr =
    //   selectedList &&
    //   selectedList.map((item) => {
    //     return item.id;
    //   });
    setSelectedUser(employeeIdArr);
    // let Employees = employeeIdArr;
    // console.log("IDS", Employees);
  };
  const onRemove = (selectedList, removedItem) => {
    console.log(
      "onRemoveselectedList ",
      selectedList,
      "removedItem",
      removedItem
    );
    // let employeeIdArr = selectedList && selectedList.map(item => { return item.id })
    // setAssignData({
    //     ...assignData,
    //     EmployeeId: employeeIdArr
    // })
  };

  const fetchEmpName = () => {
    PostCallWithErrorResponse(ApiConfig.EMPLOEE_NAME_LIST)
      .then((res) => {
        console.log("ATTENDANCE_PATH==>", res);
        if (res?.json?.Success === true) {
          setEmployeeNames(res?.json?.Data);
          setEmpName(res?.json?.Data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changePasswd = (e) => {
    
    e.preventDefault();


    if(!strongPassword(newPassword) || !userId){

      setIsPasswordValided(true)  

      return
    }


    let data = {
      EmployeeId: userId,
      ChangePassword: newPassword,
    };
    PostCallWithErrorResponse(
      ApiConfig.CHANGE_PASSWORD_BY_ADMIN,
       JSON.stringify(data)
    ).then((res) => {
        console.log("Response ---->>>>", res);
        if (res.json.Success === true) {
          ToastMsg("success", res.json?.Message);
          // setEmpName(res.json.Data);
          setUserId('')
          setNewPassword('')
        } else {
          ToastMsg("error", res.json?.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitGenericUser = (e) => {

    if(!genericUserId){
      setIsGnericValided(true)
      return
    }

    e.preventDefault();
    let data = {
      Id: 0,
      GenericUserId: genericUserId,
      Employees: selectedUser,
    };
    PostCallWithErrorResponse(ApiConfig.SET_GENERIC_USERS, JSON.stringify(data))
      .then((res) => {
        if (res.json.Success === true) {
          setgenericUserId(0);
          setSelectedUser([]);
          multiselectRef.current.resetSelectedValues();
          swal(res.json.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getGenericUserMapping = (id) => {
    console.log("getGenericUserMapping", id);
    simpleGetCallWithToken(ApiConfig.GET_GENERIC_USER_MAPPING + id)
      .then((res) => {
        console.log("getGenericUserMapping", res);
        if (res.Success === true && res.Data.EmployeeDetails.length > 0) {
          setMapping(true);
          setSelectedEmployee(res?.Data?.EmployeeDetails);
        } else {
          fetchEmpName();
          setMapping(false);
        }
      })
      .catch((err) => {
        setMapping(false);
        console.log(err);
      });
  };

  useEffect(() => {
    fetchEmpName();
  }, []);

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
          <div className="sub-header-role ">
            <h6 className="mt-2">General Setting</h6>
          </div>
          <div className="settingsCard">
            <div className="row">
              <div className="col-lg-6">
                <div className="my-3">
                  <label htmlFor="" className="enter-role-text mt-2">
                    Generic User
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setgenericUserId(Number(e.target.value));
                      getGenericUserMapping(Number(e.target.value));
                    }}
                    value={genericUserId}
                  >
                    <option selected value="0">
                      Select Compliance Type
                    </option>
                    <option value="279">Accounts</option>
                    <option value="5032">Human Resource</option>
                    <option value="5033">Delivery Escalation</option>
                    <option value="5034">Application Support</option>
                    <option value="5035">Server Support</option>
                    {/* {
                                        empName.map((name, index) => {
                                            return (
                                                <option value={name.ProjectId}>{name.ProjectName}</option>
                                            )
                                        })
                                    } */}
                  </select>
                  <p className="text-danger">{isGenericValided&&!genericUserId&&'Please Select Generic User'}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="my-3">
                  <label htmlFor="" className="enter-role-text mt-2">
                    Forward To
                  </label>
                  {mapping == true ? (
                    <Multiselect
                      options={employeeNames?.map((data) => {
                        return { id: data.Id, name: data.FullName };
                      })}
                      selectedValues={selectedEmployee?.map((data) => {
                        return {
                          id: data.EmployeeId,
                          name: data.EmployeeName,
                        };
                      })}
                      ref={multiselectRef}
                      onSelect={onSelect}
                      onRemove={onRemove}
                      displayValue="name"
                      closeOnSelect="false"
                      className=""
                    />
                  ) : (
                    // <Select
                    //   options={employeeNames?.map((data) => ({
                    //     value: data.Id,
                    //     label: data.FullName,
                    //   }))}
                    //   value={selectedEmployee?.map((data) => ({
                    //     value: data.EmployeeId,
                    //     label: data.EmployeeName,
                    //   }))}
                    //   onChange={(selected) => {
                    //     onSelect(selected);
                    //   }}
                    //   isMulti
                    //   closeMenuOnSelect={false}
                    //   classNamePrefix="react-select"
                    //   className=""
                    //   ref={multiselectRef}
                    // />
                    // <Select
                    //   options={employeeNames?.map((data) => ({
                    //     value: data.Id,
                    //     label: data.FullName,
                    //   }))}
                    //   value={selectedEmployee?.map((data) => ({
                    //     value: data.EmployeeId,
                    //     label: data.EmployeeName,
                    //   }))}
                    //   onChange={(selected) => {
                    //     onSelect(selected);
                    //   }}
                    //   isMulti
                    //   closeMenuOnSelect={false}
                    //   classNamePrefix="react-select"
                    //   className=""
                    //   ref={multiselectRef}
                    // />
                    <Multiselect
                      options={employeeNames?.map((data) => {
                        return { id: data.Id, name: data.FullName };
                      })}
                      ref={multiselectRef}
                      onSelect={onSelect}
                      onRemove={onRemove}
                      displayValue="name"
                      closeOnSelect="false"
                      className=""
                    />
                  )}
                  <p className="text-danger">{isGenericValided&&!selectedUser?.length&&'Please Select User'}</p>
                </div>
              </div>
            </div>
            <div className="col-md-12 text-end mt-2">
              <button
                className="impButton"
                onClick={(e) => {
                  submitGenericUser(e);
                }}
              >
                Update
              </button>
            </div>
          </div>

          <div className="settingsCard">
            <div className="row">
              <h6 className="py-2" style={{fontSize:"18px",fontWeight:"600"}}>Change User Password</h6>
              <div className="col-lg-6">
                <div className="my-3">
                  <label htmlFor="" className="enter-role-text mt-2">
                    User Name
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setUserId(Number(e.target.value));
                    }}
                    value={userId}
                  >
                    <option selected value="0">
                      Select User Name
                    </option>
                    {empName?.map((name, index) => {
                      return <option value={name.Id}>{name.FullName}</option>;
                    })}
                  </select>
                  <p className="text-danger">{isPasswordValided&&!userId&&'Please Select User'}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="my-3">
                  <label htmlFor="" className="enter-role-text mt-2">
                    Change Password
                  </label>
                  <input
                    value={newPassword}
                    name="ChangePassword"
                    type="text"
                    className="date-label-input tasKCategory1"
                    style={{
                      //   fontSize: "14px",
                      //   height: "38px",
                      borderRadius: "10px",
                    }}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                    }}
                  />
                  <p className="text-danger">{isPasswordValided&&!strongPassword(newPassword)&&'Please Enter Password Minimum 8 Charecters With Atleast 1 Special Charecter !'}</p>
                </div>
              </div>
            </div>
            <div className="col-md-12 text-end mt-2">
              <button
                className="impButton"
                onClick={(e) => {
                  changePasswd(e);
                }}
              >
                Update
              </button>
            </div>
          </div>

          {/* Add Locations */}
          {/* <div className="settingsCard">
            <br />
            <h3>Add Department</h3>
            <div className="col-lg-6">
              <div className="my-3">
                <label htmlFor="" className="enter-role-text mt-2">
                  Add New Department
                </label>
                <input

                  name="password"
                  type="text"
                  className="date-label-input tasKCategory1"
                  style={{
    
                    borderRadius: "10px",
                  }}
                />{" "}
                <br />
                <br />
                <button
                  className="impButton"
                  onClick={(e) => {
             
                  }}
                >
                  Add
                </button>
              </div>
              <div className="col-md-12 text-end mt-2"></div>
            </div>

            <table id="tabledash">
              <thead>
                <tr className="table-row">
                  <th className="col">Sr.no</th>
                  <th className="col">Department</th>
                  <th className="col">Edit / Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>HR</td>
                  <td>Edit-icn / Delete-icn</td>
                </tr>
                
              </tbody>
            </table>
        
            <div className="col-md-12 text-end mt-2">
              <button
                className="impButton"
                onClick={(e) => {
                 
                }}
              >
                Submit
              </button>
            </div>
          </div> */}

          {/*End  Add Locations */}
        </div>
      </div>
    </>
  );
};

export default GeneralSetting;
